import {ReturnTextAndImg} from "../../test/CheckImg";
import {ru} from "../../data/ru";
import {by} from "../../data/by";
import {ReactComponent as ArrowIcon} from "../../../img/arrow-feedback.svg";


export default function ComplexTaskTexts({texts,deleteT,upFunction,downFunction}) {
  let language = localStorage.getItem('lang') === 'ru' ?  ru.RoleIdThree: by.RoleIdThree;


  const testTexts = texts.map((item,index) => {
    const text = ReturnTextAndImg(item.text,{maxHeight:'50px'})
    return (
        <div key={`visible${item.id}`} className="test-creator-one-question">
          <div className="test-creator-question-create">
            <button onClick={(e) => deleteT(e, item.id)} className="test-creator-test-closeButton">&times;</button>
            <div>
              <div>{item.title}</div>
              <div>{text}</div>
            </div>
            <div className="test-creator-up-down-button">
              <span onClick={()=>upFunction(index)}><ArrowIcon className={'upArrow'}/></span>
              <span onClick={()=>downFunction(index)}><ArrowIcon/></span>
            </div>
            
          </div>
      </div>
    )
  })

  return (
    <>
      <p>{language.TextsForAComplexTask}:</p>
      {testTexts}
    </>
  )
}